import React from "react";
import PropTypes from "prop-types";
import { Col, Form, Row,  InputGroup } from "react-bootstrap";

class CurrencyField extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isEditing: false };
  }

  onChange(event) {
    this.props.onChange(event);
  }

  toCurrency(number) {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 2
    });

    return formatter.format(number);
  }

  toggleEditing(event) {
    this.setState({ isEditing: !this.state.isEditing });
    this.props.onBlur(event);
  }

  render() {
    return (
      <div>
        
        {this.state.isEditing ? (
          <Form.Control
            type="number"
            name={this.props.name}
            value={this.props.value}
            onChange={this.onChange.bind(this)}
            onBlur={this.toggleEditing.bind(this)}
          />
        ) : (
          <Form.Control
            type="text"
            name={this.props.name}
            value={this.toCurrency(this.props.value)}
            onFocus={this.toggleEditing.bind(this)}
            
          />
        )}
      </div>
    );
  }
}

CurrencyField.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};

export default CurrencyField;